const GLOBAL_PERMISSIONS = {
  SUPER_USER: 'superuser',
  HIDE_USER_PROFILE: 'hide:user_profile',
  HIDE_ANALYTICS_BETA: 'hide:analytics_beta',
  VIEW_DASHBOARDS: 'view:dashboards',
  EDIT_DASHBOARD: 'edit:dashboard',
  EDIT_ACCESSIBILITY: 'edit:accessibility',
};

const ACCOUNT_PERMISSIONS = {
  VIEW_SECTION_FILES: 'view:files',
  VIEW_SECTION_REPORTS: 'view:reports',
  CREATE_DATA_SOURCE: 'create:data_source',
  CREATE_DATA_SOURCE_WEBSITE: 'create:data_source:website',
  CREATE_DATA_SOURCE_OTHER: 'create:data_source:other',
  EDIT_USERS: 'edit:users',
  EDIT_POLICIES: 'edit:policies',
  EDIT_REPORT: 'edit:report',
  EDIT_CUSTOMER: 'edit:customer',
  EDIT_ALLOW_PERSONAL_DATA: 'edit:allow_personal_data',
  EDIT_FUNNEL: 'edit:funnel',
  VIEW_DEMO: 'view:demo',
  VIEW_GLOBAL_SEGMENTS: 'view:global_segments',
  EDIT_GLOBAL_SEGMENTS: 'edit:global_segments',
  EDIT_CUSTOMER_DASHBOARD: 'edit:customer_dashboard',
  EDIT_API_KEYS: 'edit:api_keys',
};

const DATA_SOURCE_PERMISSIONS = {
  CREATE_SURVEY: 'create:survey',
  EDIT_DATA_SOURCE: 'edit:data_source',
  EDIT_SURVEY: 'edit:survey',
  EDIT_SURVEY_CSS: 'edit:survey_css',
  DELETE_QUESTION_WITH_RESPONSES: 'delete:question_with_responses',
  EDIT_FLAGGED_COMMENT: 'edit:flagged_comment',
  EDIT_TAGGED_COMMENT: 'edit:tagged_comment',
  EDIT_SEGMENT: 'edit:segment',
  EDIT_SHARED_SEGMENT: 'edit:shared_segment',
  EDIT_MATOMO: 'edit:matomo',
  EDIT_HEATMAPS: 'edit:heatmaps',
  EDIT_SESSION_RECORDINGS: 'edit:session_recordings',
  EDIT_GOALS: 'edit:goals',
  EDIT_LICENSE: 'edit:license',
  VIEW_BROKEN_LINKS: 'view:broken_links',
  EDIT_TAG_MANAGER: 'edit:tag_manager',
  AUTO_TAG: 'auto_tag',
  EDIT_CONTACT_QUESTION: 'edit:contact_question',
};

module.exports = {
  GLOBAL_PERMISSIONS,
  ACCOUNT_PERMISSIONS,
  DATA_SOURCE_PERMISSIONS,
  ...GLOBAL_PERMISSIONS,
  ...ACCOUNT_PERMISSIONS,
  ...DATA_SOURCE_PERMISSIONS,
};
